/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _Typography = _interopRequireWildcard(require("../Typography"));
var _ListContext = _interopRequireDefault(require("../List/ListContext"));
var _zeroStyled = require("../zero-styled");
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _listItemTextClasses = _interopRequireWildcard(require("./listItemTextClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes, inset, primary, secondary, dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, _composeClasses.default)(slots, _listItemTextClasses.getListItemTextUtilityClass, classes);
};
const ListItemTextRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                ["& .".concat(_listItemTextClasses.default.primary)]: styles.primary
            },
            {
                ["& .".concat(_listItemTextClasses.default.secondary)]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [".".concat(_Typography.typographyClasses.root, ":where(& .").concat(_listItemTextClasses.default.primary, ")")]: {
        display: 'block'
    },
    [".".concat(_Typography.typographyClasses.root, ":where(& .").concat(_listItemTextClasses.default.secondary, ")")]: {
        display: 'block'
    },
    variants: [
        {
            props: (param)=>{
                let { ownerState } = param;
                return ownerState.primary && ownerState.secondary;
            },
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: (param)=>{
                let { ownerState } = param;
                return ownerState.inset;
            },
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const ListItemText = /*#__PURE__*/ React.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children, className, disableTypography = false, inset = false, primary: primaryProp, primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps, slots = {}, slotProps = {}, ...other } = props;
    const { dense } = React.useContext(_ListContext.default);
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography,
        inset,
        primary: !!primary,
        secondary: !!secondary,
        dense
    };
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, _useSlot.default)('root', {
        className: (0, _clsx.default)(classes.root, className),
        elementType: ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState,
        ref
    });
    const [PrimarySlot, primarySlotProps] = (0, _useSlot.default)('primary', {
        className: classes.primary,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, _useSlot.default)('secondary', {
        className: classes.secondary,
        elementType: _Typography.default,
        externalForwardedProps,
        ownerState
    });
    if (primary != null && primary.type !== _Typography.default && !disableTypography) {
        primary = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrimarySlot, {
            variant: dense ? 'body2' : 'body1',
            component: (primarySlotProps === null || primarySlotProps === void 0 ? void 0 : primarySlotProps.variant) ? undefined : 'span',
            ...primarySlotProps,
            children: primary
        });
    }
    if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
        secondary = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SecondarySlot, {
            variant: "body2",
            color: "textSecondary",
            ...secondarySlotProps,
            children: secondary
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
"production" !== "production" ? ListItemText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Alias for the `primary` prop.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */ disableTypography: _propTypes.default.bool,
    /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */ inset: _propTypes.default.bool,
    /**
   * The main content element.
   */ primary: _propTypes.default.node,
    /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ primaryTypographyProps: _propTypes.default.object,
    /**
   * The secondary content element.
   */ secondary: _propTypes.default.node,
    /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ secondaryTypographyProps: _propTypes.default.object,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        primary: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        secondary: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        primary: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        secondary: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ])
} : void 0;
var _default = exports.default = ListItemText;
